<template>
  <div class="content" style="height:100%;">
    <td >
	    <img class :src="(examType === 'pre' || examType === '') && preCoverUrl ? preCoverUrl : (examType === 'beh' && behCoverUrl) ?  behCoverUrl : defaultCoverUrl" style="width:100%;display:block" />
		  <!-- <img class="" src="../../assets/images/logo.png" style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"/> -->
		</td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->

    <div class="card">
      <div class="footer-top" style="height:35px;"></div>
      <img class="success" src="../../assets/images/success.png" />
      <div class="footer">注册成功</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "registerSuccess",
  data() {
    return {
      openid: this.$route.query.openid,
      meetingId: this.$route.query.meetingId,
      examId: this.$route.query.examId,
      defaultCoverUrl: require('../../assets/images/top.jpg')
    }
  },
  created() {
    console.log('openid:' + this.openid)
    console.log('meetingId:' + this.meetingId)
    console.log('examId:' + this.examId)
    if (this.examId) {
      const openid = this.openid
      const meetingId = this.meetingId
      const examId = this.examId
      setTimeout(() => {
        this.$router.push({ 
          name: 'exam', 
          query: { openid: openid, meetingId: meetingId, examId: examId }
        })
      }, 2000)
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  background-color: #fff;
  .banner {
    width: 100%;
    height: auto;
  }

  .card {
    position: relative;
    top: -175px;
    width: 90%;
    margin-bottom: 30px;
    height: 70vh;
    margin: 0 auto;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
    }

    .success {
      display: block;
      width: 50%;
      height: auto;
      margin: 40px auto;
    }

    .footer {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
